import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@ds';

type SignOutModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSignOut: () => void;
};

export const SignOutModal = ({ isOpen, onClose, onSignOut }: SignOutModalProps) => {
  return (
    <Modal
      size="sm"
      isOpen={isOpen}
      onClose={onClose}
      backdrop="opaque"
      hideCloseButton
      classNames={{
        wrapper: 'z-420',
        backdrop: 'z-419',
      }}
    >
      <ModalContent>
        {(handleClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">Log Out</ModalHeader>
            <ModalBody>Are you sure you want to log out?</ModalBody>
            <ModalFooter>
              <Button size="md" variant="outline" onClick={handleClose}>
                Cancel
              </Button>
              <Button size="md" color="default" variant="solid" onClick={onSignOut}>
                Confirm
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
